export const CategoryIcons: string[] = [
  "🍔",
  "🍕",
  "🍟",
  "🌭",
  "🥪",
  "🌮",
  "🌯",
  "🥙",
  "🍗",
  "🍖",
  "🍤",
  "🍣",
  "🍱",
  "🍛",
  "🍜",
  "🍝",
  "🍲",
  "🍥",
  "🥘",
  "🥗",
  "🥣",
  "🥫",
  "🍳",
  "🥓",
  "🧀",
  "🥞",
  "🧇",
  "🥖",
  "🥐",
  "🍞",
  "🥨",
  "🥔",
  "🍠",
  "🌽",
  "🥕",
  "🧄",
  "🧅",
  "🥦",
  "🥬",
  "🥒",
  "🌶️",
  "🍆",
  "🍅",
  "🥑",
  "🍄",
  "🍎",
  "🍏",
  "🍐",
  "🍊",
  "🍋",
  "🍌",
  "🍉",
  "🍇",
  "🍓",
  "🍈",
  "🍒",
  "🍑",
  "🥭",
  "🍍",
  "🥥",
  "🥝",
  "🍅",
  "🥑",
  "🌶️",
  "🍩",
  "🍪",
  "🎂",
  "🍰",
  "🧁",
  "🥧",
  "🍫",
  "🍬",
  "🍭",
  "🍮",
  "🍯",
  "🍼",
  "🥛",
  "☕",
  "🍵",
  "🧃",
  "🥤",
  "🍶",
  "🍺",
  "🍻",
  "🥂",
  "🍷",
  "🍸",
  "🍹",
  "🧉",
  "🥃",
  "🍾",
  "🧊",
  "🧂",
  "🥡",
  "🥢",
  "🍽️",
  "🍴",
  "🥄",
  "🔪",
  "🏺",
  "🥠",
  "🥟",
  "🍙",
  "🍚",
  "🍘",
  "🍢",
  "🍡",
  "🥮",
  "🍧",
  "🍨",
  "🍦",
  "🥯",
  "🧈",
  "🥩",
  "🍔",
  "🌮",
  "🍕",
  "🍜",
  "🍛",
  "🍝",
  "🥪",
  "🌯",
  "🥙",
  "🍤",
  "🍣",
  "🍱",
  "🍲",
  "🥘",
  "🍗",
  "🍖",
  "🥓",
  "🍳",
  "🧀",
  "🥞",
  "🧇",
  "🥖",
  "🥐",
  "🍞",
  "🥨",
  "🥔",
  "🌽",
  "🥕",
  "🥦",
  "🥬",
  "🥒",
  "🌶️",
  "🍆",
  "🍅",
  "🥑",
  "🍄",
  "🍎",
  "🍊",
  "🍋",
  "🍌",
  "🍉",
  "🍇",
  "🍓",
  "🍒",
  "🍑",
  "🥭",
  "🍍",
  "🥥",
  "🥝",
  "🍩",
  "🍪",
  "🎂",
  "🍰",
  "🧁",
  "🥧",
  "🍫",
  "🍬",
  "🍭",
  "🍮",
  "🍯",
  "🥛",
  "☕",
  "🍵",
  "🧃",
  "🥤",
  "🍶",
  "🍺",
  "🍻",
  "🥂",
  "🍷",
  "🍸",
  "🍹",
  "🧉",
  "🥃",
  "🍾",
  "🍡",
  "🍢",
  "🍘",
  "🍙",
  "🍚",
  "🥟",
  "🥠",
  "🍧",
  "🍨",
  "🍦",
  "🥯",
  "🧈",
  "🥩",
  "🍗",
  "🍖",
  "🥓",
  "🍳",
  "🧀",
  "🥞",
  "🧇",
]
